import * as React from "react";
import { Text, TextStyle, StyleSheet, StyleProp } from "react-native";

import StyledText from "./StyledText";

type Props = React.ComponentProps<typeof Text> & {
    style?: StyleProp<TextStyle>;
    children: React.ReactNode;
};

// @component-group Typography

/**
 * Typography component for showing a subheading.
 *
 * <div class="screenshots">
 *   <img src="screenshots/subheading.png" />
 * </div>
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { Subheading } from 'react-native-simple-elements/components/Text';
 *
 * const MyComponent = () => (
 *   <Subheading>Subheading</Subheading>
 * );
 *
 * export default MyComponent;
 * ```
 */
const Subheading = (props: Props) => (
    <StyledText
        {...props}
        alpha={0.87}
        family="regular"
        style={[styles.text, props.style]}
    />
);

export default Subheading;

const styles = StyleSheet.create({
    text: {
        fontSize: 16,
        lineHeight: 24,
        marginVertical: 2,
        letterSpacing: 0.5,
    },
});
